import { ROLE_USER_CONFIG } from '@/configs/constants';
import { RoleUserType } from '@/types/enums';
import { useTranslation } from 'react-i18next';

interface RoleProps {
    roleId: RoleUserType
}

export default function Role({ roleId }: RoleProps) {
    // hooks
    const { t } = useTranslation();

    return (
        <div>
            {roleId ? t(`${ROLE_USER_CONFIG[roleId].name}`) : <></>}
        </div>
    );
}
